import { Activity, type CSSProperties } from 'react'
import {
  Group,
  Panel,
  Separator,
  useDefaultLayout,
} from 'react-resizable-panels'
import { Outlet } from 'react-router'

import { NavigationTabsBar } from '../../components/navigationTabs/NavigationTabsBar'
import { WorkspaceAndBranchStatusFooter } from '../../components/workspaceAndBranchFooter/WorkspaceAndBranchStatusFooter'
import { useLayoutContext } from '../../context/layoutContext'
import { useNavigationParams } from '../../system/useNavigationParams'
import { LeftBar } from './LeftBar'
import { LeftSideBar } from './LeftSideBar'

export const LayoutPanels = () => {
  const { server, layer } = useNavigationParams()
  const { preferences } = useLayoutContext()
  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    groupId: 'layoutPanels',
    storage: localStorage,
  })
  return (
    <div className="grid size-full grid-cols-[auto_1fr]">
      <LeftBar />
      <Group
        id="mainPanels"
        orientation="horizontal"
        defaultLayout={defaultLayout}
        onLayoutChanged={onLayoutChanged}
      >
        <Activity
          mode={preferences.leftSidebar !== 'collapsed' ? 'visible' : 'hidden'}
        >
          <Panel defaultSize="20%" minSize="5%" id="pickerBar">
            <LeftSideBar />
          </Panel>
          <Separator
            id="resizePickerBar"
            className="w-1 dark:bg-slate-700 bg-slate-300"
          />
        </Activity>
        <Panel
          id="contentsPanel"
          className="grid h-full grid-rows-[auto_1fr_auto]"
          style={
            {
              '--topBar-height': '40px',
            } as CSSProperties
          }
        >
          {/**
           Tabs are persisted per server/layer pair. In order to avoid unwanted race conditions inside the NavigationTabsBar
           between effects and read operations from local storage, it's important that the tabs bar gets remounted each time the
           layer or server changes.
           */}
          <NavigationTabsBar key={`${server}-${layer.toString()}`} />
          <div className="size-full overflow-hidden">
            <Outlet />
          </div>
          <WorkspaceAndBranchStatusFooter />
        </Panel>
      </Group>
    </div>
  )
}
